var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"icon":"","color":"#739CA7","data-cy":"callback"},on:{"click":_vm.handleCallback}},[_c('v-icon',[_vm._v("mdi-phone-outgoing")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }